import { TOKEN_KEY, USER_INFO_KEY, PAGE_NAME, GLOBAL_MUTE_KEY, AUTHORITY, TENANT_ID_KEY } from '@/enums'
import { queryUserInfo, UserInfo, logout as logoutApi } from '@/api'
import { useStorage } from '@da-vinci/hooks'
import { getCancelError, pauseOtherVideo, sleep } from '@da-vinci/utils'
import { router } from '@/router'
import { goHome } from '@/utils'

export const useUserStore = defineStore('user', () => {
  const token = useStorage(TOKEN_KEY, '')
  const setToken = async (val?: string) => {
    logout(true)
    token.value = val
    if (val) {
      await sleep(100)
    }
    return goHome({ replace: true })
  }

  const storageUserInfo = useStorage<UserInfo>(USER_INFO_KEY, {} as UserInfo)
  const tenantId = useStorage(TENANT_ID_KEY, '')
  const setTenantId = (val?: string) => {
    tenantId.value = val ? val.toString() : undefined
  }
  const storageUserVal = computed(() => (storageUserInfo.value?.userId ? storageUserInfo.value : undefined))
  const userInfoRes = ref<UserInfo | null>()
  const noneInit = computed(() => userInfoRes.value === undefined)
  const userInfo = computed({
    get: () => (noneInit.value ? undefined : userInfoRes.value ?? storageUserVal.value),
    set: (res) => (storageUserInfo.value = res),
  })
  const nowTenant = computed(() =>
    userInfo.value?.tenantInfo?.find((e) => e.tenantId?.toString() === tenantId.value?.toString())
  )
  const judgeAmount = (price: number) => {
    return new Promise((resolve, reject) => {
      const nowAmount = nowTenant.value?.amount || 0
      if (price > nowAmount) {
        Message.warning('团队算力值不足，请联系商务经理进行反馈')
        reject(getCancelError())
      }
      resolve(true)
    })
  }
  const setUserInfo = (val?: UserInfo) => {
    userInfo.value = val
    userInfoRes.value = val
  }
  const updateUserInfo = async () => {
    try {
      const res = await queryUserInfo()
      if (res?.userId) {
        setUserInfo(res)
      } else {
        userInfoRes.value = null
      }
    } catch (e) {
      userInfoRes.value = null
    }
  }
  const initUser = async () => {
    if (noneInit.value) {
      await updateUserInfo()
    }
    if (!userInfo.value) {
      return false
    }
    if (!nowTenant.value) {
      if (tenantId.value) setTenantId()
      const tenantInfo = userInfo.value.tenantInfo || []
      if (tenantInfo.length === 1) {
        setTenantId(tenantInfo[0].tenantId)
      }
    }
  }

  const authority = computed(() => {
    if (!token.value || !userInfo.value?.userId) return AUTHORITY.needLogin
    if (!userInfo.value?.hasSetAccountName || !userInfo.value.hasSetPassword) return AUTHORITY.needFirstSet
    if (IS.isNullOrUndef(nowTenant.value?.tenantId)) return AUTHORITY.needChooseTenant
    return AUTHORITY.ok
  })

  async function logout(isClear?: boolean) {
    token.value = undefined
    pauseOtherVideo()
    setUserInfo()
    setTenantId()
    if (isClear) return
    await router.replace({ name: PAGE_NAME.LOGIN })
    token.value && logoutApi({ token: token.value })
  }

  const mutes = useStorage(GLOBAL_MUTE_KEY, {} as Record<string, boolean>, undefined)
  const globalMuted = computed({
    get: () => mutes.value[userInfo.value?.userId || 'visitor'] ?? true,
    set: (val: boolean) => {
      const key = userInfo.value?.userId || 'visitor'
      mutes.value[key] = val
    },
  })

  return {
    token,
    setToken,
    userInfo,
    initUser,
    updateUserInfo,
    logout,
    globalMuted,
    authority,
    noneInit,
    tenantId,
    nowTenant,
    judgeAmount,
  }
})
